import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { SWRConfig } from "swr";

import LoginPage from "./pages/LoginPage";
import TempDashBoard from "./pages/DashBoard";
import Brands from "./pages/brands/Brands";
import SocialMedia from "./pages/socialMedia/SocialMedia";
import Roaster from "./pages/roaster/Roaster";
import BrandDetails from "./pages/BrandDetails/BrandDetails";
import TopicalCalender from "./pages/topicalCalender/TopicalCalender";
import NotFound from "./pages/notFound/NotFound";
import ComingSoon from "./pages/comingSoon/ComingSoon";

import theme from "./theme";
import fetcher from "./apis/fetcher";

import "./App.css";
import "./pages/NotFound.css";
import TalentDashboard from "./pages/talentDashboard/TalentDashboard";
import MovieDashboard from "./pages/movieDashboard/MovieDashboard";
import GamesDashboard from "./pages/gamesDashboard/GamesDashboard";
import AdminDashboard from "./pages/adminDashboard/AdminDashboard";
import OnboardingScreen from "./pages/onboardingScreen/OnboardingScreen";
import UserProfile from "./pages/userProfile/UserProfile";
import MonitoredUserList from "./pages/userList/UserList";
import useAuth from "./context";
import NewsletterRouter from "./pages/newsletter/NewsletterRouter";
import ChatGPT from "./pages/chatGPT/ChatGPT";
import OverlapFollowers from "./pages/overlap/OverlapFollowers";
import VoiceCloningRouter from "./pages/voiceCloning/VoiceCloningRouter";
import AiAvatarRouter from "./pages/aiAvatar/AiAvatarRouter";
import ContentIdeator from "./pages/contentIdeator/ContentIdeator";
import ContentIdeatorKavya from "./pages/contentIdeator/ContentIdeatorKavya";
import YouTube from "./pages/youtube/YouTube";
import ChannelInsights from "./pages/youtube/ChannelInsights";

// eslint-disable-next-line react/prop-types
function ProtectedRoute({ element }) {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? element : <Navigate to="/" />;
}

function App() {
    const auth = useAuth();

    return (
        <ThemeProvider theme={theme}>
            <SWRConfig
                value={{
                    fetcher: fetcher(auth),
                }}
            >
                <Routes>
                    <Route
                        path="/"
                        element={
                            auth.isAuthenticated ? (
                                <Navigate to="/dashboard/brands" replace />
                            ) : (
                                <LoginPage auth={auth} />
                            )
                        }
                    />

                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute
                                element={<TempDashBoard auth={auth} />}
                            />
                        }
                    >
                        <Route
                            index
                            element={<Navigate to="brands" replace />}
                        />
                        <Route path="brands" element={<Brands />} />
                        <Route
                            path="brand-details/:brandId"
                            element={<BrandDetails />}
                        />
                        <Route path="social-media" element={<SocialMedia />} />
                        <Route path="roaster" element={<Roaster />} />
                        <Route
                            path="topical-calender"
                            element={<TopicalCalender />}
                        />
                        <Route
                            path="talent-dashboard"
                            element={<TalentDashboard />}
                        />
                        <Route
                            path="product-integration"
                            element={<ComingSoon />}
                        />
                        <Route path="monetize" element={<ComingSoon />} />
                        <Route
                            path="newsletter/*"
                            element={<NewsletterRouter />}
                        />

                        <Route
                            path="admin-dashboard"
                            element={<AdminDashboard />}
                        />
                        <Route
                            path="games-dashboard"
                            element={<GamesDashboard />}
                        />
                        {/* <Route path="onboarding" element={<Onboard />} /> */}

                        <Route
                            path="movie-dashboard"
                            element={<MovieDashboard />}
                        />
                        <Route path="user-details" element={<UserProfile />} />
                        <Route
                            path="onboarding"
                            element={<OnboardingScreen />}
                        />
                        <Route
                            path="view-user"
                            element={<MonitoredUserList />}
                        />

                        <Route
                            path="content-ideator"
                            element={<ContentIdeator />}
                        />
                        <Route
                            path="content-ideator/kavya"
                            element={<ContentIdeatorKavya />}
                        />
                        <Route
                            path="content-ideator/create"
                            element={<ComingSoon />}
                        />
                        <Route
                            path="create-avatar/*"
                            element={<AiAvatarRouter />}
                        />

                        <Route
                            path="voice-cloning/*"
                            element={<VoiceCloningRouter />}
                        />

                        {/* <Route path="voice-cloning" element={<ComingSoon />} /> */}
                        <Route path="ask-me-anything" element={<ChatGPT />} />
                        <Route path="overlap" element={<OverlapFollowers />} />
                        <Route path="youtube" element={<YouTube />} />
                        <Route path="channel/:id" element={<ChannelInsights />} />

                        <Route path="*" element={<NotFound />} />
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </SWRConfig>
        </ThemeProvider>
    );
}

export default App;
